(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "normalizr", "../setting", "../../user/schema", "../../location/schema"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("normalizr"), require("../setting"), require("../../user/schema"), require("../../location/schema"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.normalizr, global.setting, global.schema, global.schema);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _normalizr, _setting, _schema, _schema2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.topicsSchema = _exports.topicSchema = void 0;

  /**
   * Schema for a single topic
   * @type {schema.Entity}
   */
  var topicSchema = new _normalizr.schema.Entity(_setting.topicEntityKey, {
    author: _schema.userSchema,
    possible_locations: [_schema2.locationSchema]
  });

  /**
   * Schema for multiple topics
   * @type {Array<schema.Entity>}
   */
  _exports.topicSchema = topicSchema;
  var topicsSchema = [topicSchema];
  _exports.topicsSchema = topicsSchema;
});